<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            子女列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <!-- <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button> -->
                    <div style="float:right">
                        <el-input  placeholder="请输入子女姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-input  placeholder="请输入子女手机号" v-model="phone" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                        <!-- <el-table-column label="性别" prop="gender" :formatter="getGender"></el-table-column> -->
                        <el-table-column label="手机号" prop="phone"></el-table-column>
                        <!-- <el-table-column label="地址" prop="areaName" ></el-table-column>
                        <el-table-column label="详细住址" prop="address" ></el-table-column> -->
                        <el-table-column label="状态" prop="status" :formatter="getStatus" ></el-table-column>
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click="handleInfo(scope.$index, scope.row)">绑定详情</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Info ref="myInfo" v-show="showModalInfo" v-bind:areaValue="areaValue" v-on:closeInfo="closeInfo" v-on:getList="getList"></Info>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Info from "./Info";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalInfo:false,
                name:'',
                phone:'',
                areaValue:[],
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:0},{name:'禁用',value:1}]
            }
        },
        components:{
            Info
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                
            },
            getGender(row,index,column){
                return column==1?'男':'女'
            },
            getStatus(row,index,column){
                return column==1?'禁用':'正常'
            },
            handleInfo(index, row) {
                this.$refs.myInfo.init(row);
                this.showModalInfo = !this.showModalInfo;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },
            closeInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Children/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        phone:this.phone,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style scoped>

</style>
